import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchStaffRegister = (query) => {
        return network.api('get', '/sdm/get-staff-register' + query);
    }

    const fetchSaleAllocations = (query) => {
        return network.api('get', '/sdm/sale-allocations' + query);
    }

    const storeSaleAllocations = (data,query) => {
        return network.api('post', '/sdm/sale-allocations' + query,data);
    }

    const fetchSaleCommissions = (query) => {
        return network.api('get', '/sdm/get-sale-commission' + query);
    }

    const incentiveRegisterProcess = (query) => {
        return network.api('get', '/sdm/incentive-process' + query);
    }

    const fetchIncentiveProcessLogList = (query) => {
        return network.api('get', '/sdm/get-process-log' + query);
    }

    const contactProfileLevelUpdate = (query) => {
        return network.api('get', '/sdm/contact-profile-level-update' + query);
    }

    const updateIncentiveProcessType = (data, processId, query) => {
        return network.api('put', '/sdm/incentive-process/'+ processId + query, data);
    }

    return {
        fetchStaffRegister,
        fetchSaleAllocations,
        storeSaleAllocations,
        fetchSaleCommissions,
        incentiveRegisterProcess,
        contactProfileLevelUpdate,
        fetchIncentiveProcessLogList,
        updateIncentiveProcessType
    }
}